import {  useState, useContext, useEffect } from "react";
import { DeletePleaPremisesFile, DownloadPleaPremisesFile, DownloadPleaPremisesFileModel, GetAllPleaPremisesByPleaId, UploadPleaPremises } from "../../../API/PleaPremisesAPI";
import { PleaPremisesFile } from "../../../Models/PleaPremisesFileModel";
import useLoading from "../../../Hooks/useLoading";
import { IResponseProps } from "../../../Interfaces/IResponseProps";
import { useToast } from '../../../antd/hooks/toast';
import { AuthContext } from "../../../Contexts/AuthContext";
import { CompanyModel } from "../../../Models/CompanyModel";
import { CloudDownloadOutlined, DeleteOutlined, FileImageOutlined } from "@ant-design/icons";
import { Button, Table, TableColumnsType, Typography, UploadProps } from "antd";
import { filterExistingFields } from "../../../antd/utils/filter";
import FIDragger from "../../../antd/components/dragger/dragger";

interface PremisesTab {
    pleaId: string; 
    company: CompanyModel
}

export const PremisesTab = ({pleaId, company} : PremisesTab) =>{

    const toast = useToast();
    const { loading, toggleLoading } = useLoading();
    const { userEmail } = useContext(AuthContext);
    const url = `${company.id}/plea/${pleaId}`;
    const [filesUpload , setFilesUpload] = useState<File[]>([]);
    const [fileList, setFileList] = useState<PleaPremisesFile[]>([])


    const getAllFiles = async () => {
        try {
            if (pleaId) {
                await GetAllPleaPremisesByPleaId(pleaId).then((resp: IResponseProps) => {
                    if (resp.statusCode == 200) {
                        setFileList(resp.data);
                    }
                });
            }
        } catch (error: any) {
            toast.error(error);
        }
    };

    const UploadPleaPremisesFile = async () => {
        try {
            toggleLoading(true);
            if (pleaId != undefined)
                var resp = await UploadPleaPremises(filesUpload, url, userEmail, pleaId)
                    .then((resp: IResponseProps) => {
                        if (resp.statusCode == 200) {
                            toast.success({ message: `Upload feito com sucesso!` });
                        }
                    })
                    .finally(() => {
                        getAllFiles();
                        toggleLoading(false);
                    });
        } catch (error: any) {
            toast.error(error);

            toggleLoading(false);
        }
    }

    const downloadModel = async () => {
        try {
            toggleLoading(true);
            await DownloadPleaPremisesFileModel().then((blobResp: any) => {
                var blob = new Blob([blobResp], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                });
                const fileURL = URL.createObjectURL(blob);
                const link = document.createElement("a");
                link.href = fileURL;
                link.setAttribute("download", 'ModeloPremissas.xlsx');
                document.body.appendChild(link);
                link.click();
                link.parentNode?.removeChild(link);
            });
        } catch (error: any) {
            toast.error(error);
            toggleLoading(false);
        } finally {
            toggleLoading(false);
        }
    }

    const downloadFileById = async (id: string, fileName: string) => {
        try {

            await DownloadPleaPremisesFile(id).then((blobResp: any) => {
                var blob = new Blob([blobResp], {
                    type: 'application/octet-stream'
                });
                const fileURL = URL.createObjectURL(blob);
                const link = document.createElement("a");
                link.href = fileURL;
                link.setAttribute("download", fileName);
                document.body.appendChild(link);
                link.click();
                link.parentNode?.removeChild(link);
            });
        } catch (error: any) {
            toast.error(error);
        } finally {

        }
    }

    const deleteFile = async (fileId: string, fileName: string) => {
        try {
            toggleLoading(true)
            if (pleaId)
                await DeletePleaPremisesFile(company.id, encodeURIComponent(fileName), fileId, pleaId).then((resp: IResponseProps) => {
                    if (resp.statusCode == 200) {
                        getAllFiles();
                    }
                }).finally(() => toggleLoading(false));
        } catch (error: any) {
            toggleLoading(false);
            toast.error(error.message);
        }
    }

    useEffect(() => {
        getAllFiles();
    }, []);

    useEffect(() => {
        console.log('Files to upload:', filesUpload);
    }, [filesUpload]);


    const props: UploadProps = {
        multiple: true,
        onChange(info) {
            const { status } = info.file;

            if (status !== 'uploading') {
                const newFile = info.file.originFileObj;
                if (newFile) {

                    setFilesUpload(prevFiles => [...prevFiles, newFile]);
                }
            }
            // if (status === 'error') {
            //     toast.error({ message: `${info.file.name} upload de arquivo falhou.` });
            // }
            if (status === 'removed') {
                const removedFile = info.file.originFileObj;
                if (removedFile) {
                    setFilesUpload(prevFiles => prevFiles.filter(existingFile => existingFile.name !== removedFile.name));
                }
            }

        },
        onDrop(e) {
        },
        onRemove(file) {
            setFilesUpload(prevFiles => prevFiles.filter(existingFile => existingFile.name !== file.name));
        },
    };

    const files: TableColumnsType = [
      {
        title: "Nome",
        dataIndex: "fileName",
        showSorterTooltip: { target: "full-header" },
        width: "40%",
        filters: filterExistingFields(fileList, "fileName"),
        onFilter: (value, record) => value === record.fileName,
        sorter: (a, b) => a.fileName.length - b.fileName.length,
      },
      {
        title: "Tamanho",
        dataIndex: "size",
        showSorterTooltip: { target: "full-header" },
        width: "25%",
        filters: filterExistingFields(fileList, "size"),
        onFilter: (value, record) => value === record.size,
        sorter: (a, b) => a.size - b.size,
      },
      {
        title: "Data do Upload",
        dataIndex: "created",
        showSorterTooltip: { target: "full-header" },
        width: "25%",
        render: (value) => {
          return (
            <div>
              <Typography>{new Date(value).toLocaleDateString()}</Typography>
            </div>
          );
        },
      },
      {
        title: "Ações",
        dataIndex: "actions",
        align: "center",
        render: (value, record) => {
          return (
            <div className="column-action">
              {
                <>
                  <CloudDownloadOutlined
                    style={{ color: "#0000A4", cursor: "pointer" }}
                    size={20}
                    onClick={() => downloadFileById(record.id, record.fileName)}
                  />
                  <DeleteOutlined
                    style={{ color: "#FF0000", cursor: "pointer"}}
                    size={20}
                    onClick={() => {
                      deleteFile(record.id, record.fileName);
                    }}
                  />
                </>
              }
            </div>
          );
        },
        width: "10%",
        showSorterTooltip: { target: "full-header" },
      },
    ];

    return (
      <>
        <div style={{ display: "flex", flexDirection: "column", gap: "10px", overflow: "hidden", marginBottom: "10px" }}>
            <Button
                style={{ alignSelf: "flex-end", fill: "#0000A4", width: "230px" }}
                size="large"
                onClick={() => {
                downloadModel();
                }}
            >
                <CloudDownloadOutlined style={{ color: "#0000A4" }} />
                <Typography style={{ color: "#0000A4" }}>Download</Typography>
            </Button>

            <FIDragger props={props}/>

            <Button
                style={{ alignSelf: "flex-end", width: "230px" }}
                size="large"
                onClick={() => {
                UploadPleaPremisesFile();
                }}>
                    <FileImageOutlined />
                    <Typography>Carregar Documentos</Typography>
                </Button>
        </div>

        <Table
          columns={files}
          className={"table-min-height"}
          dataSource={fileList}
          pagination={{
            pageSizeOptions: [7, 10, 20, 30],
            defaultPageSize: 7,
          }}
          showSorterTooltip={{ target: "sorter-icon" }}
        />
      </>
    );
}